import { createSlice } from '@reduxjs/toolkit';

import { handleGetInquiryList } from './actions';
import { IInquiriesState, TInquiriesListKey } from './slice.interface';

const initialStateChunk = {
  data: [],
  isLoading: false,
  error: false,
  pagination: { page: 1 },
};

const initialState: IInquiriesState = {
  [TInquiriesListKey.InProgress]: initialStateChunk,
  [TInquiriesListKey.Complete]: initialStateChunk,
};

export const inquiriesListSlice = createSlice({
  name: 'inquiries-list',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(handleGetInquiryList.pending, (state: IInquiriesState, action) => {
        state[action.meta.arg.key].isLoading = true;
        state[action.meta.arg.key].error = false;
      })
      .addCase(handleGetInquiryList.rejected, (state: IInquiriesState, action) => {
        state[action.meta.arg.key].isLoading = false;
        state[action.meta.arg.key].error = true;
      })
      .addCase(handleGetInquiryList.fulfilled, (state: IInquiriesState, action) => {
        state[action.meta.arg.key].isLoading = false;
        state[action.meta.arg.key].data = action.payload.data.tableData;
        state[action.meta.arg.key].pagination = action.payload.data.pagination;
      });
  },
});

export default inquiriesListSlice.reducer;
